import { InsuranceType } from './InsuranceType';

export class InsuranceTypeOption {
    id: InsuranceType;
    name: string;
    shortName: string;
    abbr: string;

    constructor(id: InsuranceType, name: string, shortName: string, abbr: string) {
        this.id = id;
        this.name = name;
        this.shortName = shortName;
        this.abbr = abbr;
    }
}

export const InsuranceTypeOptions: InsuranceTypeOption[] = [
    new InsuranceTypeOption(InsuranceType.GeneralLiability, 'Liability', 'GL', 'GL'),
    new InsuranceTypeOption(InsuranceType.BuildersRisk, "Builder's Risk", 'BR', 'BR'),
    new InsuranceTypeOption(InsuranceType.WorkmansComp, "Workman's Comp.", 'WC', 'WC'),
    new InsuranceTypeOption(InsuranceType.Dwelling, 'Dwelling/Property', 'DW', 'DW'),
    new InsuranceTypeOption(InsuranceType.Flood, 'Flood', 'FL', 'FL'),
    new InsuranceTypeOption(InsuranceType.Other, 'Other', 'OT', 'OT'),
];
